import Login from '../components/routes/auth/Login.vue'
import Reset from '../components/routes/auth/PasswordReset.vue'
import Forgot from '../components/routes/auth/PasswordForgot.vue'
import Registration from '../components/routes/auth/Registration.vue'
import RegistrationConfirm from '../components/routes/auth/RegistrationConfirm.vue'
import EmailUpdateConfirm from '../components/routes/auth/EmailUpdateConfirm.vue'

import Homepage from '../components/routes/home/Home'
import DataPrivacy from '../components/routes/website/DataPrivacy'
import Imprint from '../components/routes/website/Imprint'
import DemoEmployeeCreate from '@/components/routes/employees/DemoEmployeeCreate'

// all routes in this list receive a flag that they are not protected by auth
const unprotectedRoutes = [{
  name: 'home',
  path: '/',
  component: Homepage
},
{
  name: 'test',
  path: '/test',
  component: DemoEmployeeCreate
},
{
  name: 'dataPrivacy',
  path: '/datenschutz',
  component: DataPrivacy
},
{
  name: 'imprint',
  path: '/impressum',
  component: Imprint
},
{
  name: 'login',
  path: '/login',
  component: Login
},
{
  name: 'registration',
  path: '/registration',
  component: Registration
},
{
  name: 'registrationConfirm',
  path: '/registration/confirm',
  component: RegistrationConfirm
},
{
  name: 'resetPassword',
  path: '/password/reset',
  component: Reset
},
{
  name: 'forgotPassword',
  path: '/password/forgot',
  component: Forgot
},
{
  name: 'emailUpdateConfirmation',
  path: '/email-update/confirm',
  component: EmailUpdateConfirm
},
{
  name: 'manifest',
  path: '/manifest.json'
},
{
  name: 'service-worker',
  path: '/service-worker.js'
}
].map(route => {
  route.meta = {
    ignoreAuth: true
  }
  return route
})

export default unprotectedRoutes
